import React from 'react';
import { useIntl } from 'react-intl';
import { get, has } from 'lodash';
import { MuiTelInput } from 'mui-tel-input';

import ControlledTextField from '../../../../../../ReactHookFormComponents/ControlledTextField';
import { QuestionTypeShowProps } from './QuestionShow';
import useSpace from '../../../../../../../Hooks/useSpace';

export default function PhoneNumberShow({
  question,
  errors,
  index,
  errorIndex,
  form,
  size,
  disabled,
  scope,
}: QuestionTypeShowProps) {
  const intl = useIntl();
  const { space } = useSpace();
  const { control } = form;
  const inputName = `${scope}answers_attributes.${index}.content`;
  const errorPath = `${scope}answers_attributes.${errorIndex}.message`;

  return (
    <ControlledTextField
      control={control}
      error={!!has(errors, errorPath)}
      helperText={get(errors, errorPath)?.message}
      name={inputName}
      size={size}
      disabled={disabled}
      slotProps={{
        inputLabel: { shrink: true },
        htmlInput: {
          'aria-label': `${question?.title}  ${intl.formatMessage({
            id: 'POST_FORM.FORM_BUILDER.PLACEHOLDER',
          })}`,
        },
      }}
      placeholder={intl.formatMessage({ id: 'POST_FORM.FORM_BUILDER.PLACEHOLDER' })}
      component={MuiTelInput}
      fullWidth
      componentProps={{
        defaultCountry: space.country_code || 'FR',
      }}
    />
  );
}
